"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var BaselineAggregation_1 = require("../model/BaselineAggregation");

var BaselineAggregationConverter_1 = require("./BaselineAggregationConverter");
/**
 * Implementation of {@link BaselineAggregationConverter BaselineAggregationConverter}.
 *
 * @author OPt
 */


var BaselineAggregationConverterImpl =
/*#__PURE__*/
function (_BaselineAggregationC) {
  _inherits(BaselineAggregationConverterImpl, _BaselineAggregationC);

  function BaselineAggregationConverterImpl() {
    _classCallCheck(this, BaselineAggregationConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(BaselineAggregationConverterImpl).apply(this, arguments));
  }

  _createClass(BaselineAggregationConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new BaselineAggregation_1.BaselineAggregation(BaselineAggregation_1.BaselineAggregation.schema.productId.valueOf(conversions.toClassReferenceId(source.productId)), BaselineAggregation_1.BaselineAggregation.schema.siteId.valueOf(conversions.toClassReferenceId(source.siteId)), BaselineAggregation_1.BaselineAggregation.schema.amount.valueOfField(source));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        productId: conversions.toDocumentReferenceId(source.productId),
        siteId: conversions.toDocumentReferenceId(source.siteId),
        amount: source.amount
      });
      return result;
    }
  }]);

  return BaselineAggregationConverterImpl;
}(BaselineAggregationConverter_1.BaselineAggregationConverter);

exports.BaselineAggregationConverterImpl = BaselineAggregationConverterImpl;